export enum MatchStatus {
  Scheduled = 'Scheduled',
  InProgress = 'InProgress',
  Finished = 'Finished',
  Postponed = 'Postponed',
}

export type TeamModel = {
  teamAbv: string;
  teamCity: string;
  teamName: string;
  teamID: string;
  division: string;
  conferenceAbv: string;
  conference: string;
  logoLgUrl: string;
  logoSmUrl: string;
};

export type BaseMatch = {
  matchId: string;
  /** Equivalent to JS `toISOString()` */
  startingDate: string;
  matchStatus: MatchStatus;
};

export type ScheduledMatchFB = {
  homeTeamId: string;
  homeTeamAbv: string;
  homeTeamPoints: number;
  awayTeamId: string;
  awayTeamAbv: string;
  awayTeamPoints: number;
  /** Starting value should be 60 minutes */
  timeRemaining: number;
} & BaseMatch;

export type Score = {
  teamId: string;
  gameId: string;
  scoreValue: number;
  scoreType: string;
  /** `Date` represented as `Date.getTime()` */
  scoreTime: number;
  quarter: number;
};

export type TeamData = {
  team: TeamModel;
  scoring: Score[];
  pointsFor: number;
  pointsAllowed: number;
};

export type ScheduledMatch = {
  home?: TeamData;
  away?: TeamData;
} & ScheduledMatchFB;

export type SelectableUnit = {
  value: number;
  label: string;
  selected?: boolean;
};

export enum DateTimeUnitKind {
  Year = 'year',
  Month = 'month',
  Date = 'date',
  Day = 'day',
  Hours = 'hours',
  AmPm = 'ampm',
  Minutes = 'minutes',
  Seconds = 'seconds',
  Milliseconds = 'milliseconds',
  Week = 'week',
  Century = 'century',
}
